export * from '@fhs/routing/src/routes/v2/cart';
export { default } from '@fhs/routing/src/routes/v2/cart';
